export default __webpack_public_path__ + "static/media/tank2-v2.34639d8c.png";